"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseFieldReferenceListItem = BaseFieldReferenceListItem;
exports.default = exports.FieldReferenceListItemStyle = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _recompose = require("recompose");
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _excluded = ["classes", "contentClassName", "theme"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
/*:: import { type FieldSuggestion } from './FieldReferenceInput';*/
/*:: type BaseProps = FieldSuggestion &
  InjectSheetProvidedProps & { contentClassName?: string };*/
var FieldReferenceListItemStyle = exports.FieldReferenceListItemStyle = function FieldReferenceListItemStyle(theme /*: ThemeType*/) {
  return {
    source: _objectSpread(_objectSpread(_objectSpread({}, theme.mixins.truncate), theme.typography.extraSmallText), {}, {
      fontSize: '.6875rem',
      lineHeight: '.9375rem',
      color: theme.colors.battleshipGrey
    }),
    content: theme.mixins.truncate,
    displayName: _objectSpread(_objectSpread(_objectSpread({}, theme.mixins.truncate), theme.typography.header5), {}, {
      fontWeight: '600',
      marginRight: '.2rem',
      maxWidth: '75%'
    }),
    type: _objectSpread(_objectSpread({}, theme.typography.header5), {}, {
      fontWeight: 400
    })
  };
};
function BaseFieldReferenceListItem(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    contentClassName = _ref /*:: */.contentClassName,
    theme = _ref /*:: */.theme,
    suggestion = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, suggestion.source && /*#__PURE__*/React.createElement("div", {
    className: classes.source
  }, suggestion.source), /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(classes.content, contentClassName)
  }, /*#__PURE__*/React.createElement("span", {
    title: suggestion.display,
    className: classes.displayName
  }, suggestion.display), /*#__PURE__*/React.createElement("span", {
    className: classes.type
  }, "(", suggestion.type, ")")));
}
BaseFieldReferenceListItem.displayName = 'BaseFieldReferenceListItem';
/*:: type EnhancedProps = FieldSuggestion & { contentClassName?: string };*/
var _default = exports.default = ((0, _recompose.compose)((0, _recompose.setDisplayName)('FieldReferenceListItem'), (0, _injectSheet.default)(FieldReferenceListItemStyle))(BaseFieldReferenceListItem) /*: React.ComponentType<EnhancedProps>*/);
//# sourceMappingURL=FieldReferenceListItem.js.map